import { render } from "./StatCategories.vue?vue&type=template&id=19ed43ff&scoped=true&ts=true"
import script from "./StatCategories.vue?vue&type=script&lang=ts"
export * from "./StatCategories.vue?vue&type=script&lang=ts"

import "./StatCategories.vue?vue&type=style&index=0&id=19ed43ff&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ed43ff"]])

export default __exports__